import { render, staticRenderFns } from "./TheCustomScroll.vue?vue&type=template&id=8b7d7422&"
import script from "./TheCustomScroll.vue?vue&type=script&lang=js&"
export * from "./TheCustomScroll.vue?vue&type=script&lang=js&"
import style0 from "./TheCustomScroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports